import React from 'react';

import Space from 'components/generic/Space.component';
import { useTranslation } from 'providers/GILT.provider';
import { formatDayToYearFullWeekdaySuffix, formatPartTime } from 'utils/date/format.util';
// TODO: update css with new and color mode

const ToggleSmsButton = ({ label, disabled, onClick, prompt, time, date }) => {
  const { t } = useTranslation();

  const formattedTime = time ? formatPartTime(time) : '';
  const formattedDate = date ? formatDayToYearFullWeekdaySuffix(date) : t('clientConnect.toggleSmsButton.beforeDate');

  return (
    <div onClick={() => onClick(label)} disabled={disabled} tabIndex={0} role="button">
      <button className={disabled ? 'btn btn-enable' : 'btn btn-disable'}>
        {disabled ? t('common.enabled').toUpperCase() : t('common.disabled').toUpperCase()}
      </button>

      <small>
        {t('clientConnect.toggleSmsButton.click')}{' '}
        <span className="fake-link">{t('clientConnect.toggleSmsButton.here')}</span>{' '}
        {t('clientConnect.toggleSmsButton.to')}{' '}
        {disabled ? t('common.disabled').toLowerCase() : t('common.enabled').toLowerCase()}{' '}
        {t('clientConnect.toggleSmsButton.them')}
      </small>

      {prompt && (
        <div className="infoText">
          {t('clientConnect.toggleSmsButton.enableByAccount')}{' '}
          {formattedTime && (
            <Space>
              {' '}
              {t('clientConnect.toggleSmsButton.at')} {formattedTime}
            </Space>
          )}{' '}
          {t('clientConnect.toggleSmsButton.on')}
          <Space>{formattedDate}</Space>
        </div>
      )}
    </div>
  );
};

export default ToggleSmsButton;
